import { render } from "./PersonalCenterView.vue?vue&type=template&id=30eb52b9&scoped=true"
import script from "./PersonalCenterView.vue?vue&type=script&lang=js"
export * from "./PersonalCenterView.vue?vue&type=script&lang=js"

import "./PersonalCenterView.vue?vue&type=style&index=0&id=30eb52b9&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30eb52b9"]])

export default __exports__